/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';


export const WidgetHelpTitleStyled = styled.span.attrs({
    className: 'widget-help__title',
})`
    ${fonts.textMainBold};
    color: ${colors.pageDashboardWidgetText};
`;

export const WidgetHelpTextStyled = styled.span.attrs({
    className: 'widget-help__text',
})`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;
